import { render, staticRenderFns } from "./LoadConfirmation.vue?vue&type=template&id=b5e0d4d2&scoped=true"
import script from "./LoadConfirmation.vue?vue&type=script&lang=js"
export * from "./LoadConfirmation.vue?vue&type=script&lang=js"
import style0 from "./LoadConfirmation.vue?vue&type=style&index=0&id=b5e0d4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0d4d2",
  null
  
)

export default component.exports